import {Pinia, Store, getActivePinia} from 'pinia';

/**
 * Uses Pinia's internal store map (`_s`) to enumerate registered stores. This is not a public API;
 * upgrades may require changes (see `pinia` version in package.json). Prefer a public iterator if
 * Pinia adds one.
 */
interface ExtendedPinia extends Pinia {
  _s: Map<string, Store>;
}

export function useResetStore() {
  const pinia = getActivePinia() as ExtendedPinia;

  if (!pinia) {
    throw new Error('There is no active Pinia instance');
  }

  const resetStore: Record<string, () => void> = {};

  for (const [name, store] of pinia._s) {
    resetStore[name] = () => {
      try {
        store.$reset();
      } catch (error) {
        console.warn(`Error resetting ${name} store:`, error);
      }
    };
  }

  resetStore.all = () => {
    for (const [, store] of pinia._s) {
      try {
        store.$reset();
      } catch (error) {
        console.warn(`Error resetting ${store.$id} store:`, error);
      }
    }
  };

  return resetStore;
}
